<template>
  <!-- 支付页面 -->
  <div class="page">
    <div
      style="
        display: flex;
        margin-top: 10px;
        background-color: #ffffff;
        padding: 10px 35px;
      "
    >
      <div style="width: 100%">
        <div class="title" style="margin-bottom: 25px">付款信息</div>
        <el-descriptions
          class="margin-top"
          title="请将保费支付到以下收款账户"
          :column="2"
          border
        >
          <el-descriptions-item
            label="账号名称："
            :labelStyle="{ 'text-align': 'right', width: '200px' }"
            >{{ list.accountName }}
          </el-descriptions-item>
          <el-descriptions-item
            label="开户行："
            :labelStyle="{ 'text-align': 'right', width: '200px' }"
            >{{ list.openBank }}
          </el-descriptions-item>
          <el-descriptions-item
            label="账号："
            :labelStyle="{ 'text-align': 'right', width: '200px' }"
            >{{ list.openBankAccount }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ 'text-align': 'right', width: '200px' }"
          >
            <template slot="label">
              <span style="color: red">保费金额：</span>
            </template>
            <span style="color: red">{{ guaFee }}元</span>
            <span style="color: red; margin-left: 50px"
              >(收费标准：保证金金额×{{list.rate*10000}}‱、最低{{list.inZhiLowerFee}}元)</span
            >
          </el-descriptions-item>
          <el-descriptions-item
            label="行号："
            :labelStyle="{ 'text-align': 'right', width: '200px' }"
            >{{ list.bankNumber }}
          </el-descriptions-item>

          <el-descriptions-item
            :labelStyle="{ 'text-align': 'right', width: '200px' }"
          >
            <template slot="label">
              <span style="color: red">备注：</span>
            </template>
            <span style="color: red"
              >付款后请务必上传支付凭证，否则可能会影响保函的开具</span
            >
          </el-descriptions-item>
        </el-descriptions>
        <div style="text-align: center">
          <el-button type="primary" style="margin: 25px 0" @click="copyTemplate"
            >复制收款账户信息</el-button
          >
        </div>
      </div>
    </div>
    <div
      style="background-color: #ffffff; padding: 10px 35px; margin-top: 15px"
    >
      <div class="title">上传支付凭证</div>
      <el-form
        ref="form"
        :model="form"
        label-position="top"
        style="margin-top: 20px"
        :rules="rules"
      >
        <div style="display: flex">
          <div style="width: 50%">
            <div v-if="daActiv">
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="账号开户行" prop="bankName">
                    <el-input v-model="form.bankName"></el-input> </el-form-item
                ></el-col>
                <el-col :span="12">
                  <el-form-item label="账户名称" prop="accountName">
                    <el-input
                      v-model="form.accountName"
                    ></el-input> </el-form-item
                ></el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="账号" prop="accountNum">
                    <el-input v-model="form.accountNum"></el-input> </el-form-item
                ></el-col>
              </el-row>
            </div>
            <el-form-item label="支付凭证：" ref="absolutePath" prop="absolutePath" style="width: 60%;">
              <el-upload
                class="upload-demo"
                action="/api/AttestationController/uploadComFile"
                :data="data"
                accept=".jpg, .png, .bmp"
                :on-success="success"
                name="enterpriseInfoFile"
                :file-list="fileList"
                :on-change="handleChange"
              >
                <div slot="tip" class="el-upload__tip">
                  支持格式：.jpg, .png且文件大小不能小于50k。
                </div>
                <el-button type="primary">
                  &nbsp;&nbsp;点击上传&nbsp;&nbsp;
                </el-button>
              </el-upload>
            </el-form-item>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              margin-left: 30px;
              width: 45%;
            "
          >
            <p
              style="
                writing-mode: vertical-rl;
                color: #8e8e8e;
                font-size: 20px;
                font-weight: bold;
                text-align: center;
              "
            >
              支付凭证图例
            </p>
            <div
              style="
                display: flex;
                margin-left: 10px;
                align-items: center;
                background-color: #f0f0f0;
                padding: 10px;
              "
            >
              <img src="../assets/credentials.png" style="width: 100%" alt="" />
            </div>
          </div>
        </div>
        <el-form-item
          label="支付流水号："
          v-if="this.type == '1'"
          prop="bankSerial"
        >
          <el-input v-model="form.bankSerial"></el-input>
        </el-form-item>
        <el-form-item
          style="display: flex; justify-content: center; margin-top: 30px"
        >
          <!-- <el-button type="primary" @click="Temporary">暂存</el-button> -->
          <el-button type="primary" @click="onSubmit('form')"
            >立即提交</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { goPay, insuranceList } from "../apis/project/index";
export default {
  data() {
    return {
      rules: {
        absolutePath: [
          { required: true, message: "请上传支付凭证", trigger: "blur" },
        ],
        bankSerial: [
          { required: true, message: "请输入支付流水号", trigger: "blur" },
        ],
        bankName: [
          { required: true, message: "请输入账号开户行", trigger: "blur" },
        ],
        accountName: [
          { required: true, message: "请输入账户名称", trigger: "blur" },
        ],
        accountNum: [
          { required: true, message: "请输入账号", trigger: "blur" },
        ],
      },
      form: {
        orderId: null,
        comCode: null,
        bankSerial: null,
        absolutePath: null,
        bankName: null,
        accountName: null,
        accountNum: null,
      },
      list: {
        // name: "安诚财产保险股份有限公司河北分公司",
        // bank: "交通银行股份有限公司石家庄熙园支行",
        // account: "131720000012017005295",
        // number: "301121000139",
        // guaFee: null,
        // tax:'行号：'
      },
      fileList: [],
      tax:null,//如果为安诚显示行号如果为大家财显示纳税人号
      guaFee:null,//保费金额
      type: null,
      daActiv: false,//如果为大家财则显示账户信息
      companyInfo:{},//账号信息
    };
  },
  methods: {
    copyTemplate() {
      this.copyToClipboard(
        "名称：" +
          this.list.accountName +
          "\n" +
          "开户行：" +
          this.list.openBank +
          "\n" +
          "账号：" +
          this.list.openBankAccount +
          "\n" +
          '行号：'  +
          this.list.bankNumber +
          "\n" +
          "保费金额：" +
          this.guaFee +
          "元"
      ); // 需要复制的文本内容
      this.$message.success("复制成功");
    },
    // 点击复制到剪贴板函数
    copyToClipboard(content) {
      if (window.clipboardData) {
        window.clipboardData.setData("text", content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData("text", content);
            e.preventDefault();
            document.oncopy = null;
          };
        })(content);
        document.execCommand("Copy");
      }
    },
    success(res) {
      console.log("res", res);
      if (res.status > 0) {
        this.$message({
          message: "支付凭证上传成功",
          type: "success",
        });
        this.form.absolutePath = res.data.absolutePath;
        this.$refs.absolutePath.clearValidate()
      } else {
        this.$message.error(res.statusInfo);
      }
    },
    Temporary() {
      this.$router.push("/order");
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          goPay(this.form).then((res) => {
            if (res.data.status > 0) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$router.push("/order");
            } else {
              this.$message.error(res.data.statusInfo);
            }
          });
        }
      });
    },
    handleChange(file, fileList) { 
      this.fileList=[fileList[fileList.length-1]]
    },
    // 根据保险公司切换不同的账号信息
    province() { 
      insuranceList({
        pageSize: 1000,
        pageNumber: 1,
        fcid:'CANG_ZHOU_AN_CHENG',
      }).then((res) => {
        const  companyArr = res.data.data.records.filter(item => {
          // 过滤不符合的保险公司
          //insuranceCompanyName为2的时候为大家财
          if (window.sessionStorage.getItem('insuranceCompanyName') == '2') {
            this.daActiv=true
            return item.identification == '2'
          }
          else {
            return item.identification == '1'
          }
        });
        this.list=companyArr[0]
      });
    //   if (window.sessionStorage.getItem('insuranceCompanyName') == '2') {
    //   this.daActiv=true
    //   this.list={
    //     name: "大家财产保险有限责任公司石家庄中心支公司",
    //     bank: "中国农业银行股份有限公司石家庄东岗路支行",
    //     account: "50369101040049703",
    //     number: "91130100MA0EPM5D43",
    //     tax:'纳税人识别号：',
    //   }
    //  }
    }
  },
  created() {
    this.province()
    this.type = window.sessionStorage.getItem("type");
    this.form.orderId = window.sessionStorage.getItem("orderId");
    this.form.comCode = window.sessionStorage.getItem("comCode");
    this.data = {
      userId: window.sessionStorage.getItem("userId"),
      isRecognition: "N",
      type: 4,
    };
    this.guaFee = window.sessionStorage.getItem("orderFee");
  },
  components: {},
};
</script>

<style scoped>
.page {
  height: 100%;
  box-sizing: border-box;
}
</style>
